import attribute_groups from "@core/gql-mockups/attribute_groups";
import { product_brand } from "@core/gql-mockups/brands";
import { product_category } from "@core/gql-mockups/categories";
import { widget_product } from "@core/gql-mockups/products";
import { mix_variants, variants } from "@core/gql-mockups/variant";
import { append_presale_to_mix_variant, append_presale_to_selection } from "@/helpers/presale";

/**
 * کارت محصول (`widget_product` هسته) + `mix_variant { presale { ... } }`.
 * کارت موجودی را از `details.count` می‌خواند و واریانتِ پیش‌فروش موجودیِ صفر
 * دارد؛ با این فیلد `ProductCard` آن را قیمت‌دار نشان می‌دهد نه «ناموجود».
 */
export const product_card = append_presale_to_mix_variant(widget_product);

/**
 * نسخه‌ی ژومنتِ `product_page_with_related_products` هسته.
 *
 * تفاوت‌ها با مدل هسته (هسته دست‌نخورده می‌ماند - قانون additive-only):
 * 1. `seo { full_url }`  - مدل هسته فقط `url` را می‌گیرد و `url` در این بک‌اند
 *    فقط اسلاگ خام است (`crop-tops-...`)، نه مسیر واقعی (`/product/crop-tops-...`).
 *    بدون این فیلد آدرسِ داخل JSON-LD به یک صفحه‌ی ۴۰۴ اشاره می‌کرد.
 * 2. `price` و `details` در ریشه‌ی محصول - برای محصولات بدونِ `mix_variant`
 *    تنها منبع قیمت و موجودیِ JSON-LD همین‌هاست.
 * 3. `summary` و `description` حذف شده‌اند - این دو بازنشسته‌اند و روی کل
 *    محصولات `null` برمی‌گردند؛ توضیحاتِ محصول حالا در ویجتِ `texteditor` بخشِ
 *    `main` می‌آید (همان چیزی که `_component.jsx` هم رندر می‌کند).
 * 4. `mix_variant { presale { available remaining lead_hours } }` - پیش‌فروش؛
 *    انتخابِ `mix_variants` هسته بدون ویرایش آن، در انتها یک فیلد می‌گیرد.
 */
export const product_page_with_related_products = `{
  id
  title
  title_en
  price_contact_number
  main_features
  has_rating
  has_comment
  has_question_box
  is_special
  user_rate
  rate_counts
  average_rate
  is_favorite
  is_notify
  strengths
  weaknesses
  comments_count(type:1)
  forums_count: comments_count(type:2)
  attribute_groups ${attribute_groups}
  variants ${variants}
  mix_variant ${append_presale_to_selection(mix_variants)}
  price {
    price
    offer_price
    has_offer
    discount_percent
    main_price
  }
  details {
    count
    product_code
    limit_min
    limit_max
    limit_max_reached
  }
  media_gallery {
    alt
    url
  }
  category ${product_category}
  brand ${product_brand}
  seo {
    url
    full_url
  }
   related_products ${product_card}
   suggestion_products ${product_card}
   custom_fields
}`;
